import React from 'react';

const Check = (
    <svg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='15' cy='15' r='14.3' stroke='#6347FF' strokeWidth='1.4' />
        <path
            d='M12.4491 18.4207L9.13019 15.1018L8 16.224L12.4491 20.6731L22 11.1222L20.8778 10L12.4491 18.4207Z'
            fill='#6347FF'
        />
    </svg>
);

export default Check;
